/* eslint-disable no-restricted-globals */

(function initializeContactForm() {
  const form = document.getElementById('contactForm');
  if (!form) return;

  const submitBtn = document.getElementById('contactSubmitBtn') || form.querySelector('button[type="submit"]');
  const statusEl = document.getElementById('contactFormStatus');

  function setStatus(message, type) {
    if (!statusEl) return;
    statusEl.hidden = false;
    statusEl.textContent = message;
    statusEl.className = `form-status is-${type}`;
  }

  function clearStatus() {
    if (!statusEl) return;
    statusEl.hidden = true;
    statusEl.textContent = '';
    statusEl.className = 'form-status';
  }

  function setBusy(isBusy) {
    if (!submitBtn) return;
    submitBtn.disabled = isBusy;
    submitBtn.textContent = isBusy ? 'Sending...' : 'Send Message';
    form.setAttribute('aria-busy', String(isBusy));
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    clearStatus();

    if (!form.reportValidity()) return;

    const formData = new FormData(form);

    try {
      setBusy(true);

      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = typeof data.message === 'string' && data.message.trim()
          ? data.message.trim()
          : 'The message could not be sent right now. Please try again in a moment.';
        setStatus(message, 'error');
        return;
      }

      form.reset();
      setStatus('Your message has been sent. Thanks for helping improve Box Builder!', 'success');
    } catch (_) {
      setStatus('Something went wrong while sending the form. Please try again in a moment.', 'error');
    } finally {
      setBusy(false);
    }
  });
}());